// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --app-shell-max-width: 1680px;
  --app-shell-gutter: 24px;
}

.navbar-container,
.dataset-shell {
  box-sizing: border-box;
  width: min(var(--app-shell-max-width), calc(100vw - (var(--app-shell-gutter) * 2)));
  margin-inline: auto;
}

.navbar .container-fluid .nav {
  width: 100%;
}

html[data-daat-integrated-tools="hidden"] .integrated-tools {
  display: none;
}

html[data-daat-density="compact"] .navbar {
  padding: 8px 12px;
}

html[data-daat-density="compact"] .dataset-sidebar,
html[data-daat-density="compact"] .dataset-toolbar,
html[data-daat-density="compact"] .model-tabs-panel {
  padding: 10px;
}

html[data-daat-density="compact"] .navbar-container {
  margin-bottom: 16px;
  padding-top: 8px;
}

html[data-daat-density="compact"] .brand-section {
  gap: 12px;
  padding-right: 14px;
}

html[data-daat-density="compact"] .integrated-tools,
html[data-daat-density="compact"] .right-navbar-container,
html[data-daat-density="compact"] .model-toolbar-actions,
html[data-daat-density="compact"] .dataset-toolbar-actions,
html[data-daat-density="compact"] .dataset-toolbar-search {
  gap: 6px;
}

html[data-daat-density="compact"] .tool-logo-link {
  width: 30px;
  height: 30px;
}

html[data-daat-density="compact"] .nav-link-enhanced {
  gap: 4px;
  padding: 6px 10px !important;
}

html[data-daat-density="compact"] .dataset-shell {
  grid-template-columns: 200px minmax(0, 1fr);
  gap: 16px;
}

html[data-daat-density="compact"] .dataset-sidebar-section + .dataset-sidebar-section,
html[data-daat-density="compact"] .dataset-sidebar-groups {
  margin-top: 14px;
  padding-top: 12px;
}

html[data-daat-density="compact"] .dataset-sidebar-item {
  gap: 8px;
  min-height: 32px;
  margin-bottom: 3px;
  padding: 5px 8px;
}

html[data-daat-density="compact"] .dataset-toolbar,
html[data-daat-density="compact"] .model-workspace-toolbar {
  min-height: 48px;
  gap: 8px;
  padding: 8px 10px;
}

html[data-daat-density="compact"] .annotation-toolbar {
  gap: 8px;
  padding: 10px;
}

html[data-daat-density="compact"] .dataset-toolbar .org-btn,
html[data-daat-density="compact"] .model-workspace-toolbar .btn,
html[data-daat-density="compact"] .model-workspace-toolbar .org-btn,
html[data-daat-density="compact"] .model-workspace-toolbar .local-model-select,
html[data-daat-density="compact"] .dataset-toolbar-search .form-control {
  min-height: 34px;
  padding-top: 6px !important;
  padding-bottom: 6px !important;
}

html[data-daat-density="compact"] .datasetGallery,
html[data-daat-density="compact"] .label-studio-projects .projectGallery,
html[data-daat-density="compact"] .model-cards-container {
  gap: 10px;
}

html[data-daat-density="compact"] .dataset-card-header {
  padding: 8px 10px 0;
}

html[data-daat-density="compact"] .dataset-card-body.card-body {
  gap: 8px;
  padding: 8px 12px 12px !important;
}

html[data-daat-density="compact"] .label-studio-projects .label-studio-project-card,
html[data-daat-density="compact"] .model-card {
  padding: 12px;
}

html[data-daat-density="compact"] .system-settings-section-heading {
  padding: 14px 20px;
}

html[data-daat-density="compact"] .system-setting-row {
  min-height: 62px;
  padding: 10px 20px;
}

html[data-daat-density="compact"] .system-settings-actions {
  padding: 10px 20px;
}

html[data-daat-density="compact"] .org-card-header {
  padding: 16px 20px;
}

html[data-daat-density="compact"] .org-card-body {
  padding: 14px 20px 6px;
}

html[data-daat-density="compact"] .table > :not(caption) > * > * {
  padding: 0.4rem 0.5rem;
}

html[data-daat-motion="reduced"] *,
html[data-daat-motion="reduced"] *::before,
html[data-daat-motion="reduced"] *::after {
  scroll-behavior: auto !important;
  transition-duration: 0.01ms !important;
  animation-duration: 0.01ms !important;
  animation-iteration-count: 1 !important;
}

@media (max-width: 600px) {
  :root {
    --app-shell-gutter: 12px;
  }
}

.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

.loading-spinner {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  min-height: 200px;
  padding: 40px 20px;
}

.loading-spinner-ring {
  display: block;
  box-sizing: border-box;
  border-width: 4px;
  border-style: solid;
  border-radius: 50%;
  animation: loading-spinner-rotate 800ms linear infinite;
}

.loading-spinner p {
  margin: 16px 0 0;
  color: #64748b;
  font-size: 14px;
}

@keyframes loading-spinner-rotate {
  to {
    transform: rotate(360deg);
  }
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/App.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA;;EAEE,sBAAsB;EACtB,mFAAmF;EACnF,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,mBAAmB;AACrB;;AAEA;;;;;EAKE,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,QAAQ;EACR,4BAA4B;AAC9B;;AAEA;EACE,2CAA2C;EAC3C,SAAS;AACX;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,QAAQ;EACR,aAAa;AACf;;AAEA;;;;;EAKE,gBAAgB;EAChB,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;;;EAGE,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,QAAQ;EACR,iCAAiC;AACnC;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;EAGE,gCAAgC;EAChC,sCAAsC;EACtC,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,uDAAuD;AACzD;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[":root {\n  --app-shell-max-width: 1680px;\n  --app-shell-gutter: 24px;\n}\n\n.navbar-container,\n.dataset-shell {\n  box-sizing: border-box;\n  width: min(var(--app-shell-max-width), calc(100vw - (var(--app-shell-gutter) * 2)));\n  margin-inline: auto;\n}\n\n.navbar .container-fluid .nav {\n  width: 100%;\n}\n\nhtml[data-daat-integrated-tools=\"hidden\"] .integrated-tools {\n  display: none;\n}\n\nhtml[data-daat-density=\"compact\"] .navbar {\n  padding: 8px 12px;\n}\n\nhtml[data-daat-density=\"compact\"] .dataset-sidebar,\nhtml[data-daat-density=\"compact\"] .dataset-toolbar,\nhtml[data-daat-density=\"compact\"] .model-tabs-panel {\n  padding: 10px;\n}\n\nhtml[data-daat-density=\"compact\"] .navbar-container {\n  margin-bottom: 16px;\n  padding-top: 8px;\n}\n\nhtml[data-daat-density=\"compact\"] .brand-section {\n  gap: 12px;\n  padding-right: 14px;\n}\n\nhtml[data-daat-density=\"compact\"] .integrated-tools,\nhtml[data-daat-density=\"compact\"] .right-navbar-container,\nhtml[data-daat-density=\"compact\"] .model-toolbar-actions,\nhtml[data-daat-density=\"compact\"] .dataset-toolbar-actions,\nhtml[data-daat-density=\"compact\"] .dataset-toolbar-search {\n  gap: 6px;\n}\n\nhtml[data-daat-density=\"compact\"] .tool-logo-link {\n  width: 30px;\n  height: 30px;\n}\n\nhtml[data-daat-density=\"compact\"] .nav-link-enhanced {\n  gap: 4px;\n  padding: 6px 10px !important;\n}\n\nhtml[data-daat-density=\"compact\"] .dataset-shell {\n  grid-template-columns: 200px minmax(0, 1fr);\n  gap: 16px;\n}\n\nhtml[data-daat-density=\"compact\"] .dataset-sidebar-section + .dataset-sidebar-section,\nhtml[data-daat-density=\"compact\"] .dataset-sidebar-groups {\n  margin-top: 14px;\n  padding-top: 12px;\n}\n\nhtml[data-daat-density=\"compact\"] .dataset-sidebar-item {\n  gap: 8px;\n  min-height: 32px;\n  margin-bottom: 3px;\n  padding: 5px 8px;\n}\n\nhtml[data-daat-density=\"compact\"] .dataset-toolbar,\nhtml[data-daat-density=\"compact\"] .model-workspace-toolbar {\n  min-height: 48px;\n  gap: 8px;\n  padding: 8px 10px;\n}\n\nhtml[data-daat-density=\"compact\"] .annotation-toolbar {\n  gap: 8px;\n  padding: 10px;\n}\n\nhtml[data-daat-density=\"compact\"] .dataset-toolbar .org-btn,\nhtml[data-daat-density=\"compact\"] .model-workspace-toolbar .btn,\nhtml[data-daat-density=\"compact\"] .model-workspace-toolbar .org-btn,\nhtml[data-daat-density=\"compact\"] .model-workspace-toolbar .local-model-select,\nhtml[data-daat-density=\"compact\"] .dataset-toolbar-search .form-control {\n  min-height: 34px;\n  padding-top: 6px !important;\n  padding-bottom: 6px !important;\n}\n\nhtml[data-daat-density=\"compact\"] .datasetGallery,\nhtml[data-daat-density=\"compact\"] .label-studio-projects .projectGallery,\nhtml[data-daat-density=\"compact\"] .model-cards-container {\n  gap: 10px;\n}\n\nhtml[data-daat-density=\"compact\"] .dataset-card-header {\n  padding: 8px 10px 0;\n}\n\nhtml[data-daat-density=\"compact\"] .dataset-card-body.card-body {\n  gap: 8px;\n  padding: 8px 12px 12px !important;\n}\n\nhtml[data-daat-density=\"compact\"] .label-studio-projects .label-studio-project-card,\nhtml[data-daat-density=\"compact\"] .model-card {\n  padding: 12px;\n}\n\nhtml[data-daat-density=\"compact\"] .system-settings-section-heading {\n  padding: 14px 20px;\n}\n\nhtml[data-daat-density=\"compact\"] .system-setting-row {\n  min-height: 62px;\n  padding: 10px 20px;\n}\n\nhtml[data-daat-density=\"compact\"] .system-settings-actions {\n  padding: 10px 20px;\n}\n\nhtml[data-daat-density=\"compact\"] .org-card-header {\n  padding: 16px 20px;\n}\n\nhtml[data-daat-density=\"compact\"] .org-card-body {\n  padding: 14px 20px 6px;\n}\n\nhtml[data-daat-density=\"compact\"] .table > :not(caption) > * > * {\n  padding: 0.4rem 0.5rem;\n}\n\nhtml[data-daat-motion=\"reduced\"] *,\nhtml[data-daat-motion=\"reduced\"] *::before,\nhtml[data-daat-motion=\"reduced\"] *::after {\n  scroll-behavior: auto !important;\n  transition-duration: 0.01ms !important;\n  animation-duration: 0.01ms !important;\n  animation-iteration-count: 1 !important;\n}\n\n@media (max-width: 600px) {\n  :root {\n    --app-shell-gutter: 12px;\n  }\n}\n\n.App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n.loading-spinner {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  min-height: 200px;\n  padding: 40px 20px;\n}\n\n.loading-spinner-ring {\n  display: block;\n  box-sizing: border-box;\n  border-width: 4px;\n  border-style: solid;\n  border-radius: 50%;\n  animation: loading-spinner-rotate 800ms linear infinite;\n}\n\n.loading-spinner p {\n  margin: 16px 0 0;\n  color: #64748b;\n  font-size: 14px;\n}\n\n@keyframes loading-spinner-rotate {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
